import { Box, Button, Typography } from "@mui/material";
import ReBox from "../../../../common/ReBox/ReBox";
import { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../../../common/Context";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import CoinCard from "../CoinCard";
import LoadingWheel from "../../../../common/LoadingWheel";
import PreviousWinners from "../PreviousWinners/PreviousWinners";
import { useTranslation } from "react-i18next";
import InfoIcon from "@mui/icons-material/Info";
import RankLegend from "../../../../common/RankLegend";
import PageNav from "../../../../common/PageNav";
import MainAreaSection from "../MainAreaSection";
import { CalendarIcon } from "../../../../common/Icons";
import SISideCard from "../SISideCard/SISideCard";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import {
  blue,
  green,
  red,
  purple,
  white,
  grey,
  background,
} from "../../../../../theme/colours";
import { CHALLENGES_POOL_AREA } from "../../../../../constants/ids";

const MoneyPot = ({ data, winners }) => {
  const { mobileView, tabletView, desktopView, setOptionState, rankData } =
    useContext(GlobalContext);

  const { t } = useTranslation("CompetitionInfo");

  const [sortedRankData, setSortedRankdata] = useState({ isLoading: true });
  const [totBubble, setTotBubble] = useState();
  const [currBubble, setCurrBubble] = useState(0);
  const [rankInfoOpen, setRankInfoOpen] = useState(false);

  const rankColors = {
    0: green[2],
    1: blue[1],
    2: purple[3],
    3: red[1],
  };

  const rankTitles = {
    0: `${t("placedRank")} ${data.rankRange}!`,
    1: `${t("topRank")}`,
    2: `${t("midRank")}`,
    3: `${t("botRank")}`,
  };

  const visibleMoneyAmt = 8;

  const moneyPotAreaStyle = {
    display: "flex",
    flexDirection: "column",
    mt: "1rem",
    padding: mobileView
      ? "1rem 1rem 0rem 1rem"
      : tabletView
      ? "0"
      : "2rem 2rem 0rem 2rem",
    borderRadius: "10px",
    width: "100%",
    height: "inherit",
    background: tabletView || mobileView ? "transparent" : white,
    boxShadow: tabletView || mobileView ? "none" : "0px 2px 3px 1px #dad8e8",
  };
  const topTextAreaStyle = {
    display: "flex",
    flexDirection: "column",
  };
  const titleStyle = { mb: "0.5rem", fontSize: mobileView ? "1rem" : "1.5rem" };
  const descStyle = {
    mb: "0.5rem",
    opacity: 0.5,
  };
  const mbRankTextStyle = {
    m: "0 0.25rem 0.5rem 0",
  };
  const bottomMoneyBoxStyle = {
    display: "flex",
    flexWrap: mobileView || tabletView ? "wrap" : "nowrap",
    justifyContent: "flex-start",
    mt: "1rem",
    width: "100%",
    pb: "1rem",
  };
  const drivingAccountAreaStyle = {
    mr: !tabletView && "1.25%",
    mb: tabletView && "1rem",
  };
  const botAccAreaStyle = {
    display: "flex",
    flexDirection: mobileView ? "column" : "row",
    height: desktopView ? "100%" : "auto",
  };
  const accountAreaStyle = {
    width: mobileView ? "100%" : tabletView ? "32%" : "39%",
    mr: !mobileView && "2.5%",
    backgroundColor: !desktopView ? white : background.primary,
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    mb: !mobileView && "1.75rem",
    borderRadius: "10px",
  };
  const drivingAccDesc = {
    display: "flex",
    flexWrap: "wrap",
    textAlign: "center",
  };
  const weekPreviewAreaStyle = {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    m: mobileView && "2rem 0",
  };
  const performanceAreaStyle = {
    mr: tabletView ? "2.5%" : mobileView ? "0%" : "1.25%",
    mb: mobileView && "2rem",
  };
  const rankAreaStyle = {
    width: "100%",
    height: "11rem",
    backgroundColor: tabletView || mobileView ? white : background.primary,
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center",
    alignItems: "center",
    borderRadius: "10px",
  };
  const rankNumberAreaStyle = {
    display: "flex",
  };
  const competitionRulesAreaStyle = {
    width: tabletView ? "57.5%" : mobileView ? "100%" : "25%",
    display: "flex",
    flexDirection: "column",
    ml: tabletView && "2.5%",
  };
  const trophyStyle = {
    color: rankColors[data.rankCode],
    m: "0.75rem 0",
    width: "2rem",
    height: "2rem",
  };
  const largeTextStyle = {
    fontSize: "3.5rem",
    fontWeight: 700,
    mb: "1rem",
    color: green[2],
  };
  const driveDescStyle = {
    fontWeight: 700,
    mr: "0.25rem",
  };
  const opacityText = {
    opacity: "30%",
  };
  const divider = {
    width: "1px",
    background: background,
    mr: "1.25%",
  };
  const leaderboardBtnStyle = {
    height: "3rem",
    width: "100%",
    mt: "1rem",
    fontSize: "1rem",
  };
  const fullCoinAreaStyle = {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    width: mobileView ? "100%" : desktopView ? "60.5%" : "70%",
  };
  const rankMsgStyle = {
    width: "100%",
  };
  const iconBoxStyle = {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
  };
  const iIconStyle = {
    color: grey[1],
    width: "0.75rem",
    height: "0.75rem",
    mb: "0.25rem",
  };
  const dialogStyle = {
    mb: rankInfoOpen && "-8rem",
    position: "absolute",
    left: tabletView ? "33%" : mobileView ? "12%" : "72%",
    bottom: tabletView ? "61%" : "95%",
    top: mobileView && "37%",
    zIndex: 1,
  };
  const mbTextStyle = {
    mb: "0.5rem",
  };

  useEffect(() => {
    if (!data) {
      return;
    }

    let temp = data.poolAmount / visibleMoneyAmt;
    (temp % visibleMoneyAmt) % 1 === 0
      ? setTotBubble(temp)
      : setTotBubble(Math.floor(temp) + 1);
  }, [data]);

  useEffect(() => {
    const sortRank = () => {
      let rData = rankData.groupRanks.filter(
        (team) => team.group.tgId === data.team_identity,
      );
      setSortedRankdata(
        rData?.length
          ? { rank: rData[0].rank, totUsers: rData[0].numUsers }
          : { rank: null, totUsers: null },
      );
    };
    rankData && sortRank();
  }, [rankData]);

  const changeNav = (type) => {
    setOptionState({ nav: type, page: "main" });
  };

  const handleBubbleNav = (type) => {
    if (type === "left" && currBubble > 0) {
      setCurrBubble((prev) => prev - 1);
    }
    if (type === "right" && currBubble < totBubble - 1) {
      setCurrBubble((prev) => prev + 1);
    }
  };

  const rankInfoStatus = () => {
    setRankInfoOpen(rankInfoOpen ? false : true);
  };

  return (
    <ReBox style={moneyPotAreaStyle} divProps={{ id: CHALLENGES_POOL_AREA }}>
      <Box sx={topTextAreaStyle}>
        <Typography variant="h2" sx={titleStyle}>
          {`${data.team_name} ${t("moneyPotTitle")}`}
        </Typography>
        <Typography variant="body1" sx={descStyle}>
          {data.description}
        </Typography>
      </Box>
      <Box sx={bottomMoneyBoxStyle}>
        <MainAreaSection
          title={t("safeDriveAcc")}
          width={desktopView ? "55%" : "100%"}
          style={drivingAccountAreaStyle}>
          <Box sx={botAccAreaStyle}>
            <Box sx={accountAreaStyle}>
              <Typography sx={largeTextStyle}>
                {`$${data.potentialBalance}`}
              </Typography>
              <Box sx={drivingAccDesc}>
                <Typography variant="body1" sx={driveDescStyle}>
                  {t("youHave")}
                  <Typography
                    display={"inline"}
                    variant="body1"
                    color={green[2]}
                    sx={driveDescStyle}>
                    {`$${data.potentialBalance}`}
                  </Typography>
                  <Typography
                    display="inline"
                    variant="body1"
                    sx={driveDescStyle}>
                    {t("safeDriveAcc2")}
                  </Typography>
                </Typography>
              </Box>
            </Box>
            <Box sx={fullCoinAreaStyle}>
              <Box sx={weekPreviewAreaStyle}>
                {totBubble &&
                  Array(
                    data.poolAmount < visibleMoneyAmt - 1
                      ? data.poolAmount
                      : data.poolAmount - (currBubble + 1) * visibleMoneyAmt > 0
                      ? visibleMoneyAmt
                      : data.poolAmount - (totBubble - 1) * visibleMoneyAmt,
                  )
                    .fill()
                    .map((item, index) => 1 + index)
                    .map((week, i) => (
                      <CoinCard
                        week={week}
                        key={i}
                        data={data}
                        page={currBubble}
                        visibleAmt={visibleMoneyAmt}
                      />
                    ))}
              </Box>
              {totBubble > 1 ? (
                <PageNav
                  handleBubbleNav={handleBubbleNav}
                  totBubble={totBubble}
                  currBubble={currBubble}
                  setCurrBubble={setCurrBubble}
                />
              ) : null}
            </Box>
          </Box>
        </MainAreaSection>
        {!tabletView && !mobileView && <Box sx={divider} />}
        <MainAreaSection
          title={`${data.score_type} ${t("week")}`}
          width={mobileView ? "100%" : tabletView ? "35%" : "20%"}
          style={performanceAreaStyle}>
          <Box sx={rankAreaStyle}>
            {sortedRankData.isLoading ? (
              <LoadingWheel width={4} />
            ) : sortedRankData.totUsers ? (
              <>
                <Box sx={iconBoxStyle}>
                  <InfoIcon sx={iIconStyle} onClick={() => rankInfoStatus()} />
                </Box>
                <Box sx={dialogStyle}>
                  {rankInfoOpen && <RankLegend rankRange={data.rankRange} />}
                </Box>
                <Box sx={rankMsgStyle}>
                  <Typography variant="h4" sx={mbTextStyle}>
                    {sortedRankData.rank
                      ? rankTitles[data.rankCode]
                      : t("noRank")}
                  </Typography>
                </Box>
                <EmojiEventsIcon sx={trophyStyle} />
                <Box sx={rankNumberAreaStyle}>
                  <Typography
                    variant="h1"
                    color={rankColors[data.rankCode]}
                    sx={mbRankTextStyle}>
                    {`#${sortedRankData.rank ?? "N/A"}`}
                  </Typography>
                  <Typography
                    variant="h1"
                    color={rankColors[data.rankCode]}
                    sx={opacityText}>
                    {`/${sortedRankData.totUsers}`}
                  </Typography>
                </Box>{" "}
              </>
            ) : (
              <Typography variant="h4">{t("rankError")}</Typography>
            )}
          </Box>
          <Button
            variant="contained"
            sx={leaderboardBtnStyle}
            onClick={() => changeNav("safeRoads")}>
            {t("goLeaderboard")}
          </Button>
        </MainAreaSection>
        {!mobileView && <Box sx={divider} />}
        <MainAreaSection
          title={t("competitionRules")}
          width={tabletView ? "57.5%" : mobileView ? "100%" : "25%"}
          style={competitionRulesAreaStyle}>
          <SISideCard
            icon={<TrackChangesIcon />}
            text={t("moneyPotRules", { rankRange: data.rankRange })}
          />
          <SISideCard icon={<CalendarIcon />} text={data.intervalRange} />
        </MainAreaSection>
      </Box>
      <PreviousWinners winnersData={winners} type="moneyPot" />
    </ReBox>
  );
};

export default MoneyPot;
